export default __webpack_public_path__ + "static/landingCityC-24d7a837dfb24974823d7685d8c9ce42.png";